import type { Picture } from './common'
import type { Topic } from './topic'
import type { User } from './user'

export interface SearchResponseBody {
	data: SearchResultItem[]
	success?: boolean
	loadMoreKey?: unknown
	highlightWord?: HighlightWord
}

export enum SearchResultItemType {
	SECTION_HEADER = 'SECTION_HEADER',
	SECTION_FOOTER = 'SECTION_FOOTER',
	TOPIC = 'TOPIC',
	USER_SECTION = 'USER_SECTION',
	ORIGINAL_POST = 'ORIGINAL_POST',
}

export interface SearchResultItem {
	type: SearchResultItemType
	sectionViewType?: 'SEARCH' | 'LESS_SEARCH_RESULTS' | 'SEARCH_MORE'
	title?: string
	id?: string
	content?: string
	subscribersCount?: number
	squarePicture?: Picture
	briefIntro?: string
	topicType?: TopicType
	isValid?: boolean
	isVerified?: boolean
	topicId?: number
	isSearchable?: boolean
	messagePrefix?: string
	internalTags?: unknown[]
	customTags?: unknown[]
	auditStatus?: string
	newCategory?: unknown[]
	involvedUsers?: null
	entryTab?: string
	tabs?: unknown[]
	rectanglePicture?: null
	pictureUrl?: string
	thumbnailUrl?: string
	subscribedStatusRawValue?: number
	subscribedAt?: string
	ref?: string
	isDreamTopic?: boolean
	isAnonymous?: boolean
	enablePictureComments?: boolean
	enablePictureWatermark?: boolean
	timeForRank?: string
	lastMessagePostTime?: Date
	createdAt?: string
	updatedAt?: string
	subscribersTextSuffix?: string
	subscribersName?: string
	friendsAlsoSubscribe?: string
	maintainer?: null
	isUserTopicAdmin?: boolean
	activitySection?: null
	activitySections?: unknown[]
	tips?: Tips
	toppingArea?: null
	inShortcuts?: boolean
	preferSection?: string
	relatedHashtags?: unknown[]
	intro?: string
	squarePostUpdateTime?: Date
	subscribersAction?: string
	approximateSubscribersCount?: string
	subscribersDescription?: string
	isCommentForbidden?: boolean
	botCount?: number
	recentPost?: string
	source?: string
	enableForUserPost?: boolean
	url?: string
	items?: User[]
	urlsInText?: unknown[]
	status?: Status
	topEndowers?: unknown[]
	hasMoreEndower?: boolean
	likeCount?: number
	commentCount?: number
	repostCount?: number
	shareCount?: number
	topic?: Topic
	pictures?: Picture[]
	collected?: boolean
	collectTime?: null
	user?: User
	isFeatured?: boolean
	repostable?: boolean
	isSuppressed?: boolean
	rollouts?: Rollouts
	subtitle?: string
	scrollingSubtitles?: ScrollingSubtitle[]
	likeIcon?: string
	readTrackInfo?: SearchResultItemReadTrackInfo
	video?: Video
	editedAt?: Date
	recordId?: string
}

export enum Ref {
	SearchIntegratePost = 'SEARCH_INTEGRATE_POST',
	SearchUser = 'SEARCH_USER',
}

export interface RefRemark {
	type: RefRemarkType
	refId: string
}

export enum RefRemarkType {
	ORIGINAL_POST = 'ORIGINAL_POST',
}

export interface StatsCount {
	topicSubscribed: number
	topicCreated: number
	followedCount: number
	followingCount: number
	highlightedPersonalUpdates: number
	liked: number
	respectedCount: number
}

export enum StoryStatus {
	None = 'NONE',
}

export enum OperateStatus {
	Online = 'ONLINE',
}

export interface SearchResultItemReadTrackInfo {
	storyStatus: StoryStatus
	recallPolicy: RecallPolicy
	recallScore: number
	rankScore: number
	reRankScore: number
}

export enum RecallPolicy {
	PostCtr = 'post_ctr',
	PostHot = 'post_hot',
}

export interface Rollouts {
	wmpShare: WmpShare
}

export interface WmpShare {
	id: string
	path: string
}

export interface ScrollingSubtitle {
	text: string
	type: ScrollingSubtitleType
}

export enum ScrollingSubtitleType {
	Common = 'COMMON',
}

export enum Status {
	Normal = 'NORMAL',
}

export interface Tips {
	inDraft: string
	inComment: string
}

export enum TopicType {
	Topic = 'TOPIC',
}

export interface Video {
	type: string
	image: Picture
	duration: number
	width: number
	height: number
}

export interface HighlightWord {
	words: string[]
	singleMaxHighlightTime: number
	totalMaxHighlightTime: number
}

export interface RelatedKeywordTip {
	url: string
	type: 'topic' | 'recruitment' | 'curiosity' | 'product' | 'keyword'
	suggestion: string
	icon: string
	description?: string
}
